import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toypool-carousel',
  templateUrl: './toypool-carousel.component.html',
  styleUrls: ['./toypool-carousel.component.scss']
})
export class ToypoolCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
